import React, { useState, useCallback, useEffect, useRef } from 'react';
// import GoogleMapReact from 'google-map-react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function index({ gatewayData, handleBack }) {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const [{ isLoading, isError, data }] = useApi();
  const [stats, setStats] = useState([]);
  const formModel = {
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const [gateways, getwaysData] = useApi();
  const [gateway, setGateways] = useState([]);
  let gatewayURL = '/zone/data?';
  const [openCreate, setOpenCreate] = useState(false);
  const day = 1000 * 60 * 60 * 24;

  useEffect(() => {
    for (let i = 0; i < gatewayData.gateways.length; i++) gatewayURL += `blegw[]=${gatewayData.gateways[i].deviceId}&`;
    user && getwaysData(gatewayURL, 'GET');
  }, [gatewayData]);

  useEffect(() => {
    if (!gateways.isLoading && !gateways.isError && gateways.data) {
      setGateways(gateways.data);
      setStats(gateways.data);
    }
  }, [gateways.isLoading, gateways.isError, gateways.data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }

    let z = stats;
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        const _data = x.data.filter((y, idx) => {
          if (y.assetName !== null) {
            return (
              y.deviceId.toLowerCase().indexOf(normalizedQuery) >= 0 ||
              y.assetName.toLowerCase().indexOf(normalizedQuery) >= 0
            );
          }
        });

        const obj = {
          blegwId: x.blegwId,
          data: _data,
        };
        const arr = [obj];
        setGateways(arr);
      });
    }
  }, [stats, formData]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  return (
    <div className="h-full w-topBar " style={{ filter: openCreate && 'blur(2px)', left: '12%', width: '100%' }}>
      <div className="flex justify-center items-center h-full w-full  z-20">
        <div style={{ width: '100%', height: '100%' }}>
          <div className="block lg:flex mt-1 lg:mt-0 absolute right-4 top-6">
            <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 py-1 rounded-sm ml-3 flex justify-between items-center rounded-md">
              <input
                type="text"
                placeholder="Search Asset/Device"
                autoComplete="off"
                className="text-textBox bg-transparent focus:outline-none"
                value={formData.q}
                name="q"
                onChange={handleInputChange}
                style={{ borderColor: '#e6e6e6' }}
              />
              <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
            </div>
          </div>
          <div className="mx-6" style={{ width: '96%' }}>
            <p className="text-lg font-bold bg-white p-2">Last Reported Devices {gatewayData.location}</p>
            <div>
              <div className="bg-tableBg ml-0 inflex_table">
                <div className="bg-tableHeader w-full flex border inflex_align" style={{ borderColor: '#e6e6e6' }}>
                  <div className="px-6 flex w-full">
                    <div className="py-4 text-left text-sm font-bold w-1/3">ASSET</div>
                    <div className="py-4 text-left text-sm font-bold w-5/12">DEVICE</div>
                    <div className="py-4 text-left text-sm font-bold w-3/4">GATEWAY</div>
                    <div className="py-4 text-left text-sm font-bold w-1/2">TEMPERATURE</div>
                    <div className="py-4 text-left text-sm font-bold w-1/2">LAST REPORTED</div>
                  </div>
                </div>
                {!gateways.isLoading ? (
                  <div
                    className="pb-1 border hideScroll"
                    style={{ borderColor: '#e6e6e6', height: '72vh', overflow: 'auto' }}
                  >
                    {gateway
                      ? gateway.map((item) =>
                          item.data.map((itm, idx) => (
                            <div
                              className="m-2.5 px-4 bg-white flex rounded-md
                      shadow-sm relative border-2 border-transparent hover:border-indigo-200 focus-within:border-indigo-200"
                            >
                              <div className="text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/3">
                                {itm?.assetName}
                              </div>
                              <div className="text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-5/12">
                                {itm?.deviceId}
                              </div>
                              <div className="text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-3/4">
                                {item?.blegwId}
                              </div>
                              <div className="text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/2">
                                {`${parseFloat(itm?.tm).toFixed(2)} ℃`}
                              </div>
                              <div className="text-role py-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/2">
                                {/* {itm.ts !== null
                                ? new Date(itm.ts).getDay() === 0
                                  ? `${new Date(itm.ts).getHours()} Hours Ago`
                                  : `${new Date(itm.ts).getDay()} Days Ago`
                                : 'N/A'} */}
                                {itm.ts !== null ? getTimeoffset(itm.ts) : 'N/A'}
                              </div>
                            </div>
                          ))
                        )
                      : null}
                  </div>
                ) : (
                  <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
